export const settingsConstants = {
  GET_REQUEST: "GET_SETTINGS_REQUEST",
  GET_SUCCESS: "GET_SETTINGS_SUCCESS",
  GET_FAILURE: "GET_SETTINGS_FAILURE",
};
